import { useEffect, useState } from 'react';

function InitInfo() {
  const [userId, setUserId] = useState();

  useEffect(() => {
   setUserId(localStorage.getItem('userId')) 
  });

  return {
    userId: userId,
  };
}

export default InitInfo;
